import { SupportedSocialMediaType } from '@anytag/shared-types';
import { InfluencerProfileMediaType } from './types';

export const checkSocialAccountType = (type?: InfluencerProfileMediaType) =>
  !!type && Object.values<string>(SupportedSocialMediaType).includes(type);
